import { Component, inject, OnInit, signal } from '@angular/core';
import { CmsService } from '@core/services-v2/cms.service';
import { GtmService } from '@core/utils-v2/gtm/gtm.service';

declare let dataLayer: any;
@Component({
  selector: 'app-slide-world-boxs',
  templateUrl: './slide-world-boxs.component.html',
  standalone: true,
  imports: [],
  styleUrls: ['./slide-world-boxs.component.scss'],
})
export class SlideWorldBoxsComponent implements OnInit {
  slides: any[] = [];
  hover: number | null = null;
  visible = signal<boolean>(false);

  responsiveOptions: any[] | undefined;
  products: any[] = [];
  private readonly gtmService = inject(GtmService);

  constructor(private readonly cmsService: CmsService) {}

  ngOnInit() {
    this.cargarMundos();
  }

  cargarMundos() {
    this.cmsService.getWorldsBoxs().subscribe({
      next: (res) => {
        this.visible.set(true);
        this.slides = res.data
          // .filter((slide) => slide.active)
          .sort((a, b) => a.order - b.order);
      },
      error: (err) => console.log(err),
    });
  }

  onClickValueBox(event: Event, index: number): void {
    event.stopPropagation();
    this.gtmService.click({
      dataLayer,
      textId: String(index + 1),
      prefix: 'value-box',
    });
  }
}
